// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___b8dfef9d02476b1b907","cls2":"FocusedNav-cls2___e79812002bf1d8b3e38 FocusedNav-cls1___b8dfef9d02476b1b907"};